import React, { useState, useContext, createContext, useMemo, useEffect } from 'react';
import { useFeatureContext } from 'contexts/FeatureContext.jsx';
import { LocalizationContext } from 'contexts/LocalizationContext.jsx';
import { OrgUserContext } from 'contexts/OrgUserContext.jsx';
import useOrgId from 'hooks/useOrgId.js';
import useProductDataOutsideRoutes from 'hooks/useProductDataOutsideRoutes.js';

export const LoadingContext = createContext({
  isLoading: false,
});

const ContextLoader = (props) => {
  const orgId = useOrgId();
  const { selectedProduct, clientId } = useProductDataOutsideRoutes();
  const featureContext = useFeatureContext();
  const localizationContext = useContext(LocalizationContext);
  const orgUserContext = useContext(OrgUserContext);
  const [delayedLoading, setDelayedLoading] = useState(true);

  const loadingStates = [featureContext.loading, localizationContext.loading, orgUserContext.loading, delayedLoading];

  const isLoading = loadingStates.some((loading) => loading);
  const value = useMemo(
    () => ({
      isLoading,
      setDelayedLoading,
    }),
    [isLoading, setDelayedLoading],
  );

  useEffect(() => {
    if ((orgId || clientId) && selectedProduct) {
      setDelayedLoading(true);
    }
  }, [orgId, selectedProduct, setDelayedLoading, clientId]);

  return <LoadingContext.Provider value={value}>{props.children}</LoadingContext.Provider>;
};

export const useLoadingContext = () => useContext(LoadingContext);

export default ContextLoader;
